export const vehicles = [
  {
    id: "minibus9",
    titleKey: "vehicles.minibus9.title",
    subtitleKey: "vehicles.minibus9.subtitle",
    image: "/minibus.webp",
    descriptionKey: "vehicles.minibus9.description",
    includesKeys: [
      "vehicles.minibus9.insurance",
      "vehicles.minibus9.assistance",
      "vehicles.minibus9.mileage",
      "vehicles.minibus9.movingOption",
      "vehicles.minibus9.fullTank"
    ],
    seats: 9,
    transmission: "Manual",
    fuel: "Diesel",
    ac: true,
    luggage: 6,
    pricing: {
      weekDayPerDay: 170,
      weekendPerDay: 170,
    },
  }
];